import { DateTime } from "luxon";

/**
 * Filter function to disallow future dates
 * @param date - The date to check
 * @returns True if the date is in the past, false otherwise
 */
export const isBeforeProvidedDate = (date: Date) => {
  // Disallow future dates
  const currentDate = DateTime.local().plus({ days: 1 }).startOf("day");
  return date < currentDate.toJSDate();
};
